<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">主体名称</div>
            <el-input v-model="listQuery.CompanyName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">业务类型</div>
            <el-select v-model="listQuery.BusiType" size="small" placeholder="" clearable>
              <el-option v-for="(item,index) in busiList" :key="index" :value="item.strParametername"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <div class="flname">风险类型</div>
            <el-select v-model="listQuery.RiskType" size="small" placeholder="" clearable>
              <el-option label="全风险" value="全风险"></el-option>
              <el-option label="免责" value="免责"></el-option>
              <el-option label="不限" value="不限"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="合同协议类型:">
            <el-select v-model="listQuery.ContractProType" size="small" placeholder="" clearable filterable>
              <el-option v-for="(item,index) in agreementList" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业:" label-width="68px">
            <el-input v-model="listQuery.SignTrade" size="small" clearable></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item>
          <el-breadcrumb-item>信息维护</el-breadcrumb-item>          <el-breadcrumb-item>文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>合同/协议模板</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="案例管理" name="/successCaseSet"></el-tab-pane>
          <el-tab-pane label="合同模板管理" name="/contractTemplateSet"></el-tab-pane>
          <el-tab-pane label="报价体系" name="/quotationGui"></el-tab-pane>
          <!-- <el-tab-pane label="三体系认证" name="/threeSystem"></el-tab-pane> -->
          <el-tab-pane label="公司介绍" name="/companyProfileSet"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;">
          <el-button type="success" size="small" @click="addTemplate">&nbsp;新增</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" style="width: 1371px;">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              <span>{{(listQuery.pageNum - 1) * listQuery.pageSize + scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="CompanyName" label="公司主体" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ContractProType" label="合同协议类型" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="BusiType" label="业务类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="SignTrade" label="可签行业" width="140" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.SignTrade ? scope.row.SignTrade.replace(/,/g,'-') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="RiskType" label="风险类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="QualificationManager" label="资质管理员" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.QualificationManagerId)" v-show="row.QualificationManagerId && row.QualificationManager" title="点击查看联系方式">{{row.QualificationManager}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="StampKeeper" label="公章管理员" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.StampKeeperid)" v-show="row.StampKeeperid && row.StampKeeper" title="点击查看联系方式">{{row.StampKeeper}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="ContractSealKeeper" label="合同章管理员" width="100" align="center">
            <template slot-scope="{row}">
              <el-popover placement="right" width="100" trigger="click">
                <el-table :data="gridData" v-loading="gridloading">
                  <el-table-column width="100" property="phone" label="联系方式"></el-table-column>
                </el-table>
                <span class="greenName cp" slot="reference" @click="getPhone(row.ContractSealKeeperid)" v-show="row.ContractSealKeeperid && row.ContractSealKeeper" title="点击查看联系方式">{{row.ContractSealKeeper}}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="200" align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column prop="ContractUrl" label="模板" width="100" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <div class="info_item_sys cp" v-if="scope.row.ContractUrl" @click="down(scope.row.ContractUrl,scope.row.ContractFileName)">{{ scope.row.ContractFileName }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addTemplate(scope.row)">编辑</span>
              <span class="info_item_sys cp" @click="del(scope.row)" style="margin-left: 10px;">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        listQuery: {
          CompanyName: '', //主体名称
          BusiType: '', //业务类型
          RiskType: '', //风险类型
          ContractProType: '', //合同协议类型
          SignTrade: '', //行业
          pageNum: 1,
          pageSize: "10"
        },
        scaleList: [],
        totalCount: 0,
        tableData: [{
          name: 'aaa',
          address: 'adsad'
        }],
        activeName: '/contractTemplateSet',
        headPath: this.$store.state.EMP.docPath,
        //协议下拉列表
        agreementList: ['劳动合同', '退休返聘协议', '实习协议', '兼职协议', '自由职业者服务协议', '劳务协议', '非全日制用工协议', '岗位/业务外包协议', '实习生托管协议', '生产外包协议', '仓储物流外包协议', '劳务派遣协议', '代理业务协议', '代理招聘协议', '咨询服务协议', '培训服务协议', '灵活用工协议'],
        gridData: [],
        gridloading: false,
        busiList: []
      };
    },
    created() {
      this.calHeight();
      this.getcontracttemplist();
      this.getTreestr('JB_base_Busitype', 'busiList');
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      getTreestr(type, list) {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: '',
          keyword: ''
        }
        xz.getTreestr(type, data).then(res => {
          if (res) {
            this[list] = res.msg.parent;
          } else {
            this[list] = [];
          }
          this.treeLoading = false;
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      //获取合同模板列表
      getcontracttemplist() {
        xz.getcontracttemplist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = `${val}`;
        this.getcontracttemplist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getcontracttemplist();
      },
      searchHandle() {
        this.getcontracttemplist();
      },
      //查看详情
      toDdetail() {
        this.$router.push({
          path: '/legalSubjectInfo'
        })
      },
      down(url,name) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
      handleClick() {
        this.$router.push({
          path: this.activeName
        })
      },
      addTemplate(row) {
        this.$router.push({
          path: "/addTemplate",
          query: {
            row: row ? JSON.stringify(row) : ''
          },
        });
      },
      del(row) {
        this.$set(row, 'IsDeleted', 1)
        xz.updatecontracttemp(row).then(res => {
          if (res.status == 'ok') {
            this.searchHandle()
            this.$message.success('删除成功')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      getPhone(id) {
        this.gridloading = true;
        let dtlQuery = {
          mainuserid:'',
          useridr: id
        }
        xz.getauthJbUserDetail(dtlQuery).then(res => {
          if (res.status == 'ok') {
            this.gridData = [{
              phone: res.msg.Strmobile
            }]
            this.gridloading = false;
          } else {
            this.$message.error('获取联系方式失败')
            this.gridData = []
            this.gridloading = false;
          }
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>
  .page_israGud .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_israGud .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_israGud .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_israGud .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_israGud .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_israGud .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_israGud .screenInputs .screenInput .el-select .el-input__inner,
  .page_israGud .re_down_form.el-form--inline .el-form-item__content,
  .page_israGud .re_down_form .el-select,
  .page_israGud .re_down_form .el-form-item__content,
  .page_israGud .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_israGud .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_israGud .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_israGud .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>